import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import MultipleTabsDesktopComponent from "./multiple-tabs-desktop/multiple-tabs-desktop-component";
import MultipleTabsMobileComponent from "./multiple-tabs-mobile/multiple-tabs-mobile-component";
export default withResponsiveHOC(MultipleTabsDesktopComponent, MultipleTabsMobileComponent);
